import { createContext, useContext } from 'react';

/** Routes that render edge-to-edge with no persistent sidebar (editors, libraries with their own panes). */
export const WORKSPACE_ROUTES: RegExp[] = [
  /^\/recordings\/[^/]+$/,
  /^\/media$/,
  /^\/avatars\/[^/]+\/preview$/,
];

export function isWorkspaceRoute(pathname: string): boolean {
  return WORKSPACE_ROUTES.some((r) => r.test(pathname));
}

/** Workflow editor & Organizer Canvas — scroll lives inside the page, not on `<main>`. */
export function isScrollContainedRoute(pathname: string): boolean {
  return /^\/workflows\/[^/]+$/.test(pathname) || pathname === '/workflows/organize';
}

export interface LayoutChrome {
  /** true when the shell is in workspace mode (no sidebar, no padding). */
  workspace: boolean;
  /** Opens the navigation drawer — pages in workspace mode render their own trigger. */
  openNav: () => void;
}

export const LayoutChromeContext = createContext<LayoutChrome>({ workspace: false, openNav: () => {} });

export function useLayoutChrome(): LayoutChrome {
  return useContext(LayoutChromeContext);
}
